module.exports = __webpack_public_path__ + "img/np.npe700d83.svg";